// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2IRGX","title":"Images45_title__3CXWV","images":"Images45_images__3YrqZ"};